<template>
  <div style="padding-top: 5%" class=" pb-2 pb-lg-16 pb-xl-16  d-block">
    <div>

      <v-row class="px-3" >
        <v-col class="d-flex flex-column justify-center align-center" cols="12" lg="12" xl="12" md="12" sm="12">
          <div class="w-80 ma-auto text-center my-4">
            <h1 class=" success--text text-right mb-6 font-weight-bold py-4">{{$t('us-projects')}}</h1>
            <div v-if="projects!=null">
              <v-row no-gutters>
                <v-col class="d-flex align-center justify-center" :class="$vuetify.breakpoint.lgAndUp?'col-border':''" v-for="(item,i) in projects.topics.slice(0,4)" :key="i" cols="12" lg="6" xl="6" md="12" sm="12" >
                  <div style="width: fit-content">
                    <router-link  :to="'/sub/light-blocks/single/'+item.id">

                      <div  style="height: 240px;width: 320px;" class="w-60 g-box  mb-10 ma-auto">
                        <v-img class="mb-3" height="240" style="position: relative" :src="item.photo_file">
                          <div class="date-box" >
         <span class="d-flex align-center justify-center">
        {{item.title}}
      </span>
                          </div>
                        </v-img>
                      </div>
                    </router-link>
<!--                    <v-img max-width="320" alt="img" @click="showImage=i ; showImageDialog=true" class="ma-3"  height="200" :src="item.photo_file"/>-->

                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div
              @click="$router.push('/sub/light-blocks/projects')"
              class="load-more"
          >
            {{$t('more')}}
          </div>
        </v-col>
<!--        <v-col class="d-flex align-center justify-center" cols="12" lg="6" xl="6" md="12" sm="12">
          <div style="width: 83%;height: 75%;" class="d-block ">
            <video style="object-fit: fill" class="ma-auto" width="100%" height="100%" controls>
              <source src="https://www.w3schools.com/html/mov_bbb.mp4">
            </video>
          </div>
        </v-col>-->
      </v-row>
      <v-dialog  width="900" class="d-flex justify-center align-center text-center"  v-model="showImageDialog">
        <v-card  width="900" height="100%">
          <v-app-bar>
            <v-icon @click="showImageDialog=false">mdi-close</v-icon>
          </v-app-bar>
          <v-carousel v-model="showImage" hide-delimiters>
            <v-carousel-item v-for="(item,index) in projects" :key="index" >
              <img alt="image" style="object-fit: fill" width="900" height="500" :src="item"/>

            </v-carousel-item>
          </v-carousel>

        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'lightBlocksProjects',
  data() {
    return {
      showImageDialog:false,
      showImage:{},
      // projects: [
      //   require('../../../../assets/images/lightBlocks/sabas.jpg'),
      //   require('../../../../assets/images/lightBlocks/parastoo.jpg'),
      //   require('../../../../assets/images/lightBlocks/amin.jpeg'),
      //   require('../../../../assets/images/lightBlocks/kharrazi.jpg'),
      // ]
    }
  },
  computed:{
    ...mapState({
      projects:state => state.lightBlocksManagement.blockProjects,
    })
  }
}
</script>
<style scoped>
.date-box {
  padding: 6px 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}

.g-box:hover > * > * > .date-box {
  background-color: #7BAD32;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}

.date-box > * {
  color: white;
  font-size: 16px !important;
}
.col-border:nth-child(1),.col-border:nth-child(3){
  border-left: 2px solid white;
}
.col-border:nth-child(3),.col-border:nth-child(4){
  border-top: 2px solid white;
}
.load-more {
  margin-bottom: 20px;
  padding: 0 22px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e8e8e8;
  font-weight: bold;
  cursor: pointer;
  background: #7BAD32;
}
.load-more:hover{
  background: #e8e8e8;
  color: #7BAD32;
  transition: all 0.5s;
}

</style>